import type { LucideIcon } from 'lucide-react'

import {
    Car,
    LayoutDashboard,
    LayoutGrid,
    ReceiptText,
    Users
} from 'lucide-react'

export type NavItem = {
    href: string
    label: string
    icon: LucideIcon
    isActive: (pathname: string) => boolean
}

export const NAV_ITEMS: NavItem[] = [
    { href: '/', label: 'Dashboard', icon: LayoutDashboard, isActive: pathname => pathname === '/' },
    { href: '/vehicles', label: 'Vehicles', icon: Car, isActive: pathname => pathname.startsWith('/vehicles') },
    { href: '/staff', label: 'Staff', icon: Users, isActive: pathname => pathname.startsWith('/staff') },
    { href: '/billing', label: 'Billing', icon: ReceiptText, isActive: pathname => pathname.startsWith('/billing') },
    { href: '/more', label: 'More', icon: LayoutGrid, isActive: pathname => pathname.startsWith('/more') }
]
